import { render, staticRenderFns } from "./OptionPrixParticipantField.vue?vue&type=template&id=52e9fcb9&scoped=true"
import script from "./OptionPrixParticipantField.vue?vue&type=script&lang=ts"
export * from "./OptionPrixParticipantField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e9fcb9",
  null
  
)

export default component.exports